import { render, staticRenderFns } from "./small_hd.vue?vue&type=template&id=3140c305&scoped=true&"
import script from "./small_hd.vue?vue&type=script&lang=js&"
export * from "./small_hd.vue?vue&type=script&lang=js&"
import style0 from "./small_hd.vue?vue&type=style&index=0&id=3140c305&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140c305",
  null
  
)

export default component.exports